import ObservablePropertyDescriptorObject from '../../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../../utils/PropertyDescriptor';
import ModelActionPropertyBase from "./ModelActionPropertyBase";

export default class Model extends ModelActionPropertyBase {

    name = new PropertyDescriptor("", '消息名称', "高级", "string", "#anticon-noun_Soundwave_1786379", {
    });

    script = new PropertyDescriptor(``, '使用 Javascript 创建消息参数', "高级", "js", "#anticon-Documentation", {
        description: '在发送消息时，使用脚本的返回值作为消息的参数',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    run(data, opts) {
        const name = this.name && this.name.trim();
        if (!name)
            return;

        const args = this.script ? opts.runScript(this.script, data, undefined, undefined, { throwException: true }) : data;
        opts.designer.raiseDataChanged(name, args);
    }

    toString() {
        return this.name;
    }
}
